import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Button } from '@mui/material';
import ArrowDropDownIcon from '../../assets/icons/ArrowDropDown.js';

var _excluded = ["endIcon", "variant", "children"];

var ActionMenuTrigger = function ActionMenuTrigger(_ref) {
  var _ref$endIcon = _ref.endIcon,
      endIcon = _ref$endIcon === void 0 ? /*#__PURE__*/React.createElement(ArrowDropDownIcon, null) : _ref$endIcon,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "contained" : _ref$variant,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? "Actions" : _ref$children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    endIcon: endIcon,
    variant: variant
  }), children);
};

var ActionMenuTrigger$1 = ActionMenuTrigger;

export { ActionMenuTrigger$1 as default };
